import { definePermissions } from '../define-permissions';

/** Module id of the platform catalog. Tenant role presets never grant anything from it. */
export const PLATFORM_MODULE = 'platform';

/**
 * Permissions of the platform operator: operations above any single tenant, executed with
 * the system database client. Only the `platform-admin` preset grants them.
 */
export const platformPermissions = definePermissions({
  module: PLATFORM_MODULE,
  resources: {
    organization: {
      actions: ['view', 'create', 'change-plan', 'view-audit', 'setup', 'reset'],
      description:
        'Provisioning and listing of organizations (tenants), their plan, their audit log, the setup of their initial data and the reset of a demo.',
    },
    plan: {
      actions: ['view', 'create', 'update'],
      description: 'The commercial plans of the platform: price and limits (archive included).',
    },
    intelligence: {
      actions: ['view', 'manage'],
      description:
        'The intelligence agent of the organizations (spec 063): requests, activation, schedule and runs.',
    },
    'plan-request': {
      actions: ['view', 'decide'],
      description: 'Plan change requests of the organizations: approve or reject them.',
    },
    unit: {
      actions: ['view', 'create'],
      description: 'Listing and creating units across every organization.',
    },
    user: {
      // Provisioning a person into an organization (with a temporary password) and support:
      // a temporary password, ending every session, and turning one membership off or on.
      actions: ['view', 'create', 'reset-password', 'end-sessions', 'update-membership'],
      description:
        'Platform users and their memberships, with the provisioning and support actions.',
    },
    'help-feedback': {
      actions: ['view', 'delete'],
      description:
        'Reading and analyzing help center article feedbacks submitted by organizations.',
    },
    transcription: {
      actions: ['view', 'update'],
      description:
        'The speech-to-text provider of the platform and which organizations may transcribe audios.',
    },
    ai: {
      actions: ['view', 'update'],
      description:
        'The LLM provider of the platform and which organizations (and members) may use the AI assistant.',
    },
  },
});

export type PlatformPermissionId = (typeof platformPermissions.ids)[number];
